export const environment = {
  production: false,
  apiBaseUrl: 'https://rolepermission.avrhrms.com',
  // apiBaseUrl: 'https://rolepermission.avrhrms.com',
  // apiBaseUrl: 'http://192.168.1.7:3001',
  firebase: {
    apiKey: 'AIzaSyCJ68Xaf7L4FOluOqunxTx8EClifzr5w4w',
    authDomain: 'avr-hrms.firebaseapp.com',
    projectId: 'avr-hrms',
    storageBucket: 'avr-hrms.firebasestorage.app',
    messagingSenderId: '614211221355',
    appId: '1:614211221355:web:554dfb6a507d1c0637be2e',
    measurementId: 'G-G8MCVCM5YW',
    vapidKey:
      'BFEujE1aNTPMSQ9a52twlQBXl-9gvAn1PgRbRnOftGNFXQNfYaNIOVVwOeJ2GhvyV-y11PkbU7oWMHapPXP_cIs'
  },
  vapidKey:
    'BFEujE1aNTPMSQ9a52twlQBXl-9gvAn1PgRbRnOftGNFXQNfYaNIOVVwOeJ2GhvyV-y11PkbU7oWMHapPXP_cIs', // add this separately
  title: 'AVR HRMS || Rolepermission'
}
